var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
const SWIPER_SCRIPT_URL$2 = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
const SWIPER_STYLE_URL$2 = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
const SWIPER_SCRIPT_ID$2 = "original-swiper-cdn-script";
const SWIPER_STYLE_ID$2 = "original-swiper-cdn-style";
let swiperLoadPromise$1 = null;
class OriginalKeyvisual extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector(".js-keyvisual-slider");
    this.pagination = this.querySelector(".js-keyvisual-pagination");
    if (!this.slider || this.swiper) {
      return;
    }
    loadSwiper$1().then(() => {
      if (!this.isConnected || this.swiper) {
        return;
      }
      this.initSwiper();
    });
  }
  disconnectedCallback() {
    if (!this.swiper) {
      return;
    }
    this.swiper.destroy(true, true);
    this.swiper = null;
  }
  initSwiper() {
    const autoplayEnabled = this.dataset.autoplay === "true";
    const autoplayDelay = Number(this.dataset.autoplayDelay) || 5e3;
    this.swiper = new window.Swiper(this.slider, {
      autoplay: autoplayEnabled ? {
        delay: autoplayDelay,
        disableOnInteraction: false
      } : false,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      loop: this.slider.querySelectorAll(".swiper-slide").length > 1,
      pagination: this.pagination ? {
        el: this.pagination,
        clickable: true
      } : false,
      slidesPerView: 1,
      speed: 900
    });
  }
}
function loadSwiper$1() {
  if (window.Swiper) {
    return Promise.resolve();
  }
  if (swiperLoadPromise$1) {
    return swiperLoadPromise$1;
  }
  appendSwiperStyle$1();
  swiperLoadPromise$1 = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(SWIPER_SCRIPT_ID$2);
    if (existingScript) {
      existingScript.addEventListener("load", resolve, { once: true });
      existingScript.addEventListener("error", reject, { once: true });
      return;
    }
    const script = document.createElement("script");
    script.id = SWIPER_SCRIPT_ID$2;
    script.src = SWIPER_SCRIPT_URL$2;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return swiperLoadPromise$1;
}
function appendSwiperStyle$1() {
  if (document.getElementById(SWIPER_STYLE_ID$2)) {
    return;
  }
  const link = document.createElement("link");
  link.id = SWIPER_STYLE_ID$2;
  link.rel = "stylesheet";
  link.href = SWIPER_STYLE_URL$2;
  document.head.appendChild(link);
}
if (!customElements.get("original-keyvisual")) {
  customElements.define("original-keyvisual", OriginalKeyvisual);
}
const FOOTER_GAP = 12;
class OriginalFloatingMenu extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector(".js-floating-menu-button");
    if (!this.button) {
      return;
    }
    this.trigger = document.querySelector(this.dataset.trigger || ".js-keyvisual");
    this.footer = document.querySelector(this.dataset.footer || ".p-footer");
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener("scroll", this.handleScroll, { passive: true });
    window.addEventListener("resize", this.handleScroll, { passive: true });
    this.handleScroll();
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleScroll);
  }
  handleScroll() {
    this.updateVisibility();
    this.updateFooterOffset();
  }
  /** 対象要素が画面に入ってきたかどうかで表示を切り替える */
  updateVisibility() {
    let hasEnteredTrigger = true;
    if (this.trigger) {
      hasEnteredTrigger = this.trigger.getBoundingClientRect().top <= window.innerHeight;
    }
    this.button.classList.toggle("is-visible", hasEnteredTrigger);
    this.button.setAttribute("aria-hidden", String(!hasEnteredTrigger));
  }
  /** フッターに重なる分だけボタンを押し上げる */
  updateFooterOffset() {
    if (!this.footer) {
      return;
    }
    const footerTop = this.footer.getBoundingClientRect().top;
    const overlap = window.innerHeight - footerTop + FOOTER_GAP;
    this.button.style.setProperty("--floating-menu-offset", `${Math.max(overlap, 0)}px`);
  }
}
if (!customElements.get("original-floating-menu")) {
  customElements.define("original-floating-menu", OriginalFloatingMenu);
}
const SWIPER_SCRIPT_URL$1 = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
const SWIPER_STYLE_URL$1 = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
const SWIPER_SCRIPT_ID$1 = "original-swiper-cdn-script";
const SWIPER_STYLE_ID$1 = "original-swiper-cdn-style";
let aboutJournalSwiperLoadPromise = null;
class OriginalAboutJournal extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector(".js-about-journal-slider");
    if (!this.slider || this.swiper) {
      return;
    }
    loadAboutJournalSwiper().then(() => {
      if (!this.isConnected || this.swiper) {
        return;
      }
      this.initSwiper();
    });
  }
  disconnectedCallback() {
    if (!this.swiper) {
      return;
    }
    this.swiper.destroy(true, true);
    this.swiper = null;
  }
  initSwiper() {
    this.swiper = new window.Swiper(this.slider, {
      breakpoints: {
        750: {
          enabled: false,
          spaceBetween: 20
        }
      },
      enabled: true,
      grabCursor: true,
      slidesPerView: "auto",
      spaceBetween: 20,
      speed: 500,
      watchOverflow: true
    });
  }
}
function loadAboutJournalSwiper() {
  if (window.Swiper) {
    return Promise.resolve();
  }
  if (aboutJournalSwiperLoadPromise) {
    return aboutJournalSwiperLoadPromise;
  }
  appendAboutJournalSwiperStyle();
  aboutJournalSwiperLoadPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(SWIPER_SCRIPT_ID$1);
    if (existingScript) {
      existingScript.addEventListener("load", resolve, { once: true });
      existingScript.addEventListener("error", reject, { once: true });
      return;
    }
    const script = document.createElement("script");
    script.id = SWIPER_SCRIPT_ID$1;
    script.src = SWIPER_SCRIPT_URL$1;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return aboutJournalSwiperLoadPromise;
}
function appendAboutJournalSwiperStyle() {
  if (document.getElementById(SWIPER_STYLE_ID$1)) {
    return;
  }
  const link = document.createElement("link");
  link.id = SWIPER_STYLE_ID$1;
  link.rel = "stylesheet";
  link.href = SWIPER_STYLE_URL$1;
  document.head.appendChild(link);
}
if (!customElements.get("original-about-journal")) {
  customElements.define("original-about-journal", OriginalAboutJournal);
}
const ABOUT_HERO_OVERLAY_MAX_OPACITY = 0.4;
const ABOUT_HERO_TITLE_MOVE_PX = 70;
const ABOUT_HERO_TITLE_MIN_SCALE = 0.75;
const ABOUT_HERO_TITLE_END_PROGRESS = 0.35;
const ABOUT_HERO_OVERLAY_END_PROGRESS = 0.45;
const ABOUT_HERO_LEAD_START_PROGRESS = 0.4;
const ABOUT_HERO_LEAD_END_PROGRESS = 0.7;
const ABOUT_HERO_SCROLL_FADE_START_PROGRESS = 0.15;
const ABOUT_HERO_SCROLL_FADE_END_PROGRESS = 0.4;
class OriginalAboutHero extends HTMLElement {
  connectedCallback() {
    this.overlay = this.querySelector(".js-about-hero-overlay");
    this.titleElement = this.querySelector(".js-about-hero-title");
    this.lead = this.querySelector(".js-about-hero-lead");
    this.scrollGuideCenter = this.querySelector(".js-about-hero-scroll-center");
    this.scrollGuideSide = this.querySelector(".js-about-hero-scroll-side");
    this.scrollSpacer = this.querySelector(".js-about-hero-spacer");
    if (!this.overlay || !this.titleElement || !this.scrollGuideCenter || !this.scrollGuideSide || !this.scrollSpacer) {
      return;
    }
    this.update = this.update.bind(this);
    this.requestUpdate = this.requestUpdate.bind(this);
    window.addEventListener("scroll", this.requestUpdate, { passive: true });
    window.addEventListener("resize", this.requestUpdate);
    this.requestUpdate();
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", this.requestUpdate);
    window.removeEventListener("resize", this.requestUpdate);
    window.cancelAnimationFrame(this.animationFrameId);
  }
  requestUpdate() {
    if (this.animationFrameId) {
      return;
    }
    this.animationFrameId = window.requestAnimationFrame(this.update);
  }
  update() {
    this.animationFrameId = null;
    const rect = this.getBoundingClientRect();
    const stickyElement = this.firstElementChild;
    const stickyTop = Number.parseFloat(window.getComputedStyle(stickyElement).top) || 0;
    const stageTop = rect.top + window.scrollY;
    const startScrollPosition = Math.max(stageTop - stickyTop, 0);
    const scrollDistance = Math.max(this.scrollSpacer.offsetHeight, 1);
    const progress = Math.min(Math.max((window.scrollY - startScrollPosition) / scrollDistance, 0), 1);
    const titleProgress = Math.min(progress / ABOUT_HERO_TITLE_END_PROGRESS, 1);
    const overlayProgress = Math.min(progress / ABOUT_HERO_OVERLAY_END_PROGRESS, 1);
    const leadProgress = Math.min(
      Math.max((progress - ABOUT_HERO_LEAD_START_PROGRESS) / (ABOUT_HERO_LEAD_END_PROGRESS - ABOUT_HERO_LEAD_START_PROGRESS), 0),
      1
    );
    const scrollFadeProgress = Math.min(
      Math.max(
        (progress - ABOUT_HERO_SCROLL_FADE_START_PROGRESS) / (ABOUT_HERO_SCROLL_FADE_END_PROGRESS - ABOUT_HERO_SCROLL_FADE_START_PROGRESS),
        0
      ),
      1
    );
    const isSideGuideActive = scrollFadeProgress >= 0.5;
    this.overlay.style.opacity = String(overlayProgress * ABOUT_HERO_OVERLAY_MAX_OPACITY);
    this.titleElement.style.setProperty("--about-hero-title-y", `${-ABOUT_HERO_TITLE_MOVE_PX * titleProgress}px`);
    this.titleElement.style.setProperty("--about-hero-title-scale", String(1 - (1 - ABOUT_HERO_TITLE_MIN_SCALE) * titleProgress));
    this.scrollGuideCenter.style.opacity = String(1 - scrollFadeProgress);
    this.scrollGuideSide.style.opacity = String(scrollFadeProgress);
    this.syncScrollGuideAccessibility(this.scrollGuideCenter, !isSideGuideActive);
    this.syncScrollGuideAccessibility(this.scrollGuideSide, isSideGuideActive);
    if (this.lead) {
      this.lead.style.opacity = String(leadProgress);
      this.lead.style.transform = `translateY(${(1 - leadProgress) * ABOUT_HERO_TITLE_MOVE_PX}px)`;
    }
  }
  syncScrollGuideAccessibility(scrollGuide, isActive) {
    if (isActive) {
      scrollGuide.removeAttribute("aria-hidden");
      scrollGuide.removeAttribute("tabindex");
      scrollGuide.style.pointerEvents = "";
      return;
    }
    scrollGuide.setAttribute("aria-hidden", "true");
    scrollGuide.setAttribute("tabindex", "-1");
    scrollGuide.style.pointerEvents = "none";
  }
}
if (!customElements.get("original-about-hero")) {
  customElements.define("original-about-hero", OriginalAboutHero);
}
const SWIPER_SCRIPT_URL = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
const SWIPER_STYLE_URL = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
const SWIPER_SCRIPT_ID = "original-swiper-cdn-script";
const SWIPER_STYLE_ID = "original-swiper-cdn-style";
let swiperLoadPromise = null;
function loadSwiper() {
  if (window.Swiper) {
    return Promise.resolve();
  }
  if (swiperLoadPromise) {
    return swiperLoadPromise;
  }
  appendSwiperStyle();
  swiperLoadPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(SWIPER_SCRIPT_ID);
    if (existingScript) {
      existingScript.addEventListener("load", resolve, { once: true });
      existingScript.addEventListener("error", reject, { once: true });
      return;
    }
    const script = document.createElement("script");
    script.id = SWIPER_SCRIPT_ID;
    script.src = SWIPER_SCRIPT_URL;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return swiperLoadPromise;
}
function appendSwiperStyle() {
  if (document.getElementById(SWIPER_STYLE_ID)) {
    return;
  }
  const link = document.createElement("link");
  link.id = SWIPER_STYLE_ID;
  link.rel = "stylesheet";
  link.href = SWIPER_STYLE_URL;
  document.head.appendChild(link);
}
const SLIDE_GAP = 20;
class OriginalAboutLineupSlider extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector(".js-about-lineup-slider");
    this.list = this.querySelector(".js-about-lineup-list");
    this.slides = [...this.querySelectorAll(".js-about-lineup-slide")];
    this.pagination = this.querySelector(".js-about-lineup-pagination");
    this.buttonPrevious = this.querySelector(".js-about-lineup-previous");
    this.buttonNext = this.querySelector(".js-about-lineup-next");
    if (!this.slider || !this.list || this.slides.length === 0) {
      return;
    }
    loadSwiper().then(() => {
      if (!this.isConnected || this.swiper) {
        return;
      }
      this.initSwiper();
    });
  }
  disconnectedCallback() {
    this.destroySwiper();
  }
  initSwiper() {
    this.slider.classList.add("swiper");
    this.list.classList.add("swiper-wrapper");
    this.slides.forEach((slide) => slide.classList.add("swiper-slide"));
    this.swiper = new window.Swiper(this.slider, {
      grabCursor: true,
      navigation: {
        nextEl: this.buttonNext,
        prevEl: this.buttonPrevious
      },
      pagination: {
        clickable: true,
        el: this.pagination
      },
      slidesPerGroup: 1,
      slidesPerView: "auto",
      spaceBetween: SLIDE_GAP,
      speed: 500,
      watchOverflow: true
    });
    this.classList.add("is-initialized");
  }
  destroySwiper() {
    var _a, _b, _c;
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    this.classList.remove("is-initialized");
    (_a = this.slider) == null ? void 0 : _a.classList.remove("swiper");
    (_b = this.list) == null ? void 0 : _b.classList.remove("swiper-wrapper");
    (_c = this.slides) == null ? void 0 : _c.forEach((slide) => slide.classList.remove("swiper-slide"));
  }
}
if (!customElements.get("original-about-lineup-slider")) {
  customElements.define("original-about-lineup-slider", OriginalAboutLineupSlider);
}
const FOOTER_ACCORDION_SELECTOR = "[data-footer-accordion]";
const FOOTER_PC_MEDIA_QUERY = "(min-width: 750px)";
class OriginalFooter extends HTMLElement {
  constructor() {
    super();
    this.mediaQuery = window.matchMedia(FOOTER_PC_MEDIA_QUERY);
    this.handleMediaChange = this.syncAccordionState.bind(this);
    this.handleToggle = this.syncExpandedState.bind(this);
  }
  connectedCallback() {
    this.accordions = [...this.querySelectorAll(FOOTER_ACCORDION_SELECTOR)];
    this.accordions.forEach((details) => details.addEventListener("toggle", this.handleToggle));
    this.syncAccordionState();
    this.mediaQuery.addEventListener("change", this.handleMediaChange);
  }
  disconnectedCallback() {
    var _a;
    (_a = this.accordions) == null ? void 0 : _a.forEach((details) => details.removeEventListener("toggle", this.handleToggle));
    this.mediaQuery.removeEventListener("change", this.handleMediaChange);
  }
  syncExpandedState(event) {
    var _a;
    const details = event.currentTarget;
    const isOpen = details.open;
    details.setAttribute("aria-expanded", isOpen ? "true" : "false");
    (_a = details.querySelector("summary")) == null ? void 0 : _a.setAttribute("aria-expanded", isOpen ? "true" : "false");
  }
  syncAccordionState() {
    const isDesktop = this.mediaQuery.matches;
    const accordions = this.accordions ?? [];
    accordions.forEach((details) => {
      const summary = details.querySelector("summary");
      if (isDesktop) {
        details.setAttribute("open", "");
        details.setAttribute("aria-expanded", "true");
        summary == null ? void 0 : summary.setAttribute("aria-expanded", "true");
        summary == null ? void 0 : summary.setAttribute("tabindex", "-1");
        return;
      }
      const shouldOpen = details.dataset.footerDefaultOpen === "true";
      details.toggleAttribute("open", shouldOpen);
      details.setAttribute("aria-expanded", shouldOpen ? "true" : "false");
      summary == null ? void 0 : summary.setAttribute("aria-expanded", shouldOpen ? "true" : "false");
      summary == null ? void 0 : summary.removeAttribute("tabindex");
    });
  }
}
if (!window.customElements.get("original-footer")) {
  window.customElements.define("original-footer", OriginalFooter);
}
class OriginalProductTotal extends HTMLElement {
  constructor() {
    super();
    this.abortController = new AbortController();
    this.additionalUnitPrice = 0;
  }
  connectedCallback() {
    var _a, _b;
    this.form = document.getElementById(this.dataset.formId);
    this.totalPrice = this.querySelector(".js-main-product-total-price");
    if (!this.form || !this.totalPrice) return;
    this.quantityInput = this.form.elements.namedItem("quantity");
    (_a = this.quantityInput) == null ? void 0 : _a.addEventListener("input", () => this.updateTotal(), { signal: this.abortController.signal });
    (_b = this.quantityInput) == null ? void 0 : _b.addEventListener("change", () => this.updateTotal(), { signal: this.abortController.signal });
    this.form.addEventListener("variant:change", (event) => this.updateProductPrice(event), { signal: this.abortController.signal });
    const productOptions = [...document.querySelectorAll("original-product-options")].find((element) => element.dataset.formId === this.dataset.formId);
    if (productOptions == null ? void 0 : productOptions.getAdditionalUnitPrice) {
      this.additionalUnitPrice = productOptions.getAdditionalUnitPrice();
    }
    this.updateTotal();
  }
  disconnectedCallback() {
    this.abortController.abort();
  }
  setAdditionalUnitPrice(price) {
    this.additionalUnitPrice = Number(price || 0);
    this.updateTotal();
  }
  updateProductPrice(event) {
    var _a, _b;
    const productPrice = Number((_b = (_a = event.detail) == null ? void 0 : _a.variant) == null ? void 0 : _b.price);
    if (!Number.isFinite(productPrice)) return;
    this.dataset.productPrice = String(productPrice);
    this.updateTotal();
  }
  updateTotal() {
    var _a;
    if (!this.totalPrice) return;
    const productPrice = Number(this.dataset.productPrice || 0);
    const productQuantity = Number(((_a = this.quantityInput) == null ? void 0 : _a.value) || 1);
    this.totalPrice.textContent = this.formatMoney((productPrice + this.additionalUnitPrice) * productQuantity);
  }
  formatMoney(price) {
    const amount = price / 100;
    const formattedPrice = new Intl.NumberFormat("ja-JP", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
    const formattedPriceWithoutDecimals = new Intl.NumberFormat("ja-JP", {
      maximumFractionDigits: 0
    }).format(amount);
    return this.dataset.moneyFormat.replace(/\{\{\s*amount_no_decimals\s*\}\}/, formattedPriceWithoutDecimals).replace(/\{\{\s*amount\s*\}\}/, formattedPrice);
  }
}
if (!window.customElements.get("original-product-total")) {
  window.customElements.define("original-product-total", OriginalProductTotal);
}
class OriginalProductOptions extends HTMLElement {
  constructor() {
    super();
    this.abortController = new AbortController();
    this.freeCandleLimit = 3;
    this.additionalCandleQuantity = 1;
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  connectedCallback() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    this.form = document.getElementById(this.dataset.formId);
    if (!this.form) return;
    this.optionMode = this.dataset.optionMode || "cake";
    this.noshiSelect = this.querySelector(".js-product-options-noshi-select");
    this.noshiDetail = this.querySelector(".js-product-options-noshi-detail");
    this.noshiHeading = this.querySelector(".js-product-options-noshi-heading");
    this.noshiSender = this.querySelector(".js-product-options-noshi-sender");
    this.candleSelect = this.querySelector(".js-product-options-candle-select");
    this.candleDetail = this.querySelector(".js-product-options-candle-detail");
    this.plateSelect = this.querySelector(".js-product-options-plate-select");
    this.plateDetail = this.querySelector(".js-product-options-plate-detail");
    this.giftBoxSelect = this.querySelector(".js-product-options-gift-box-select");
    this.giftBoxDetail = this.querySelector(".js-product-options-gift-box-detail");
    this.messageFields = [...this.querySelectorAll(".js-product-options-message")];
    (_a = this.noshiSelect) == null ? void 0 : _a.addEventListener("change", () => this.updateNoshi(), { signal: this.abortController.signal });
    (_b = this.noshiSender) == null ? void 0 : _b.addEventListener("input", () => this.updateNoshiCharacterCount(), { signal: this.abortController.signal });
    (_c = this.candleSelect) == null ? void 0 : _c.addEventListener("change", () => this.updateCandle(), { signal: this.abortController.signal });
    (_d = this.plateSelect) == null ? void 0 : _d.addEventListener("change", () => this.updatePlate(), { signal: this.abortController.signal });
    (_e = this.giftBoxSelect) == null ? void 0 : _e.addEventListener("change", () => this.updateGiftBox(), { signal: this.abortController.signal });
    (_f = this.querySelector(".js-product-options-candle-minus")) == null ? void 0 : _f.addEventListener("click", () => this.changeCandleQuantity(-1), { signal: this.abortController.signal });
    (_g = this.querySelector(".js-product-options-candle-plus")) == null ? void 0 : _g.addEventListener("click", () => this.changeCandleQuantity(1), { signal: this.abortController.signal });
    this.messageFields.forEach((field) => {
      const input = field.querySelector("textarea");
      input == null ? void 0 : input.addEventListener("input", () => {
        field.querySelector(".js-product-options-character-count").textContent = [...input.value].length;
      }, { signal: this.abortController.signal });
    });
    this.form.addEventListener("submit", this.handleSubmit, { capture: true, signal: this.abortController.signal });
    this.quantityInput = this.form.elements.namedItem("quantity");
    (_h = this.quantityInput) == null ? void 0 : _h.addEventListener("input", () => this.updateTotal(), { signal: this.abortController.signal });
    (_i = this.quantityInput) == null ? void 0 : _i.addEventListener("change", () => this.updateTotal(), { signal: this.abortController.signal });
    if (this.optionMode === "noshi") this.updateNoshi();
    else if (this.optionMode === "gift-card") this.updateGiftBox();
    else {
      this.updateCandle();
      this.updatePlate();
    }
    this.updateTotal();
  }
  disconnectedCallback() {
    this.abortController.abort();
  }
  updateNoshi() {
    var _a;
    const needsNoshi = ((_a = this.noshiSelect) == null ? void 0 : _a.value) !== "不要";
    if (this.noshiDetail) this.noshiDetail.hidden = !needsNoshi;
    if (this.noshiHeading) this.noshiHeading.disabled = !needsNoshi;
    if (this.noshiSender) this.noshiSender.disabled = !needsNoshi;
  }
  updateNoshiCharacterCount() {
    var _a;
    const characterCount = this.querySelector(".js-product-options-noshi-character-count");
    if (characterCount) characterCount.textContent = [...((_a = this.noshiSender) == null ? void 0 : _a.value) || ""].length;
  }
  changeCandleQuantity(amount) {
    var _a;
    const candleValue = ((_a = this.candleSelect) == null ? void 0 : _a.value) || "0";
    const currentQuantity = candleValue === "more" ? this.freeCandleLimit + this.additionalCandleQuantity : Number(candleValue);
    const nextQuantity = Math.max(1, currentQuantity + amount);
    if (nextQuantity > this.freeCandleLimit) {
      this.candleSelect.value = "more";
      this.additionalCandleQuantity = nextQuantity - this.freeCandleLimit;
    } else {
      this.candleSelect.value = String(nextQuantity);
    }
    this.updateCandle();
  }
  updateCandle() {
    var _a;
    const candleValue = ((_a = this.candleSelect) == null ? void 0 : _a.value) || "0";
    const hasCandles = candleValue !== "0";
    const usesPaidCandles = candleValue === "more";
    if (this.candleDetail) this.candleDetail.hidden = !hasCandles;
    if (!hasCandles) {
      this.updateTotal();
      return;
    }
    const candlePrice = Number(this.dataset.candlePrice || 0);
    const totalCandleQuantity = usesPaidCandles ? this.freeCandleLimit + this.additionalCandleQuantity : Number(candleValue);
    const additionalCandleSubtotal = usesPaidCandles ? candlePrice * this.additionalCandleQuantity : 0;
    this.querySelector(".js-product-options-candle-detail-title").textContent = usesPaidCandles ? "追加のロウソク" : "ロウソク";
    this.querySelector(".js-product-options-candle-unit-price").hidden = !usesPaidCandles;
    this.querySelector(".js-product-options-candle-quantity").textContent = totalCandleQuantity;
    this.querySelector(".js-product-options-candle-total").textContent = totalCandleQuantity;
    this.querySelector(".js-product-options-candle-subtotal").textContent = this.formatMoney(additionalCandleSubtotal);
    this.updateTotal();
  }
  updatePlate() {
    var _a;
    const plateQuantity = Number(((_a = this.plateSelect) == null ? void 0 : _a.value) || 0);
    if (this.plateDetail) this.plateDetail.hidden = plateQuantity === 0;
    this.messageFields.forEach((field, index) => {
      const isActive = index < plateQuantity;
      const input = field.querySelector("textarea");
      field.hidden = !isActive;
      input.required = isActive;
      if (!isActive) input.value = "";
    });
    if (plateQuantity > 0) {
      const platePrice = Number(this.dataset.messagePlatePrice || 0);
      this.querySelector(".js-product-options-plate-total").textContent = plateQuantity;
      this.querySelector(".js-product-options-plate-subtotal").textContent = this.formatMoney(platePrice * plateQuantity);
    }
    this.updateTotal();
  }
  updateGiftBox() {
    var _a;
    const needsGiftBox = ((_a = this.giftBoxSelect) == null ? void 0 : _a.value) === "1";
    if (this.giftBoxDetail) this.giftBoxDetail.hidden = !needsGiftBox;
    this.updateTotal();
  }
  getAdditionalUnitPrice() {
    var _a, _b, _c;
    const candlePrice = ((_a = this.candleSelect) == null ? void 0 : _a.value) === "more" ? Number(this.dataset.candlePrice || 0) * this.additionalCandleQuantity : 0;
    const platePrice = Number(this.dataset.messagePlatePrice || 0) * Number(((_b = this.plateSelect) == null ? void 0 : _b.value) || 0);
    const giftBoxPrice = Number(this.dataset.giftBoxPrice || 0) * Number(((_c = this.giftBoxSelect) == null ? void 0 : _c.value) || 0);
    return candlePrice + platePrice + giftBoxPrice;
  }
  updateTotal() {
    var _a;
    const additionalUnitPrice = this.getAdditionalUnitPrice();
    const productTotal = [...document.querySelectorAll("original-product-total")].find((element) => element.dataset.formId === this.dataset.formId);
    if (productTotal == null ? void 0 : productTotal.setAdditionalUnitPrice) {
      productTotal.setAdditionalUnitPrice(additionalUnitPrice);
      return;
    }
    const totalPrice = productTotal == null ? void 0 : productTotal.querySelector(".js-main-product-total-price");
    if (!totalPrice) return;
    const productPrice = Number(this.dataset.productPrice || 0);
    const productQuantity = Number(((_a = this.quantityInput) == null ? void 0 : _a.value) || 1);
    totalPrice.textContent = this.formatMoney((productPrice + additionalUnitPrice) * productQuantity);
  }
  formatMoney(price) {
    const amount = price / 100;
    const formattedPrice = new Intl.NumberFormat("ja-JP", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
    const formattedPriceWithoutDecimals = new Intl.NumberFormat("ja-JP", {
      maximumFractionDigits: 0
    }).format(amount);
    return this.dataset.moneyFormat.replace(/\{\{\s*amount_no_decimals\s*\}\}/, formattedPriceWithoutDecimals).replace(/\{\{\s*amount\s*\}\}/, formattedPrice);
  }
  createGroupId() {
    var _a;
    if ((_a = window.crypto) == null ? void 0 : _a.randomUUID) return window.crypto.randomUUID();
    return `option-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }
  getMessages() {
    return this.messageFields.filter((field) => !field.hidden).map((field) => field.querySelector("textarea").value.trim());
  }
  validateMessages() {
    let isValid = true;
    this.messageFields.forEach((field) => {
      const input = field.querySelector("textarea");
      const shouldValidate = !field.hidden;
      input.setCustomValidity(shouldValidate && input.value.trim() === "" ? "メッセージを入力してください。" : "");
      if (shouldValidate && !input.reportValidity()) isValid = false;
    });
    return isValid;
  }
  getBaseProperties(formData) {
    const properties = {};
    for (const [key, value] of formData.entries()) {
      const matchedKey = key.match(/^properties\[(.+)]$/);
      if (matchedKey && value !== "") properties[matchedKey[1]] = value;
    }
    return properties;
  }
  createGroupItems(variantId, baseProperties) {
    var _a, _b, _c, _d, _e, _f;
    const groupId = this.createGroupId();
    if (this.optionMode === "noshi") {
      const noshiType = ((_a = this.noshiSelect) == null ? void 0 : _a.value) || "不要";
      const needsNoshi = noshiType !== "不要";
      const parentProperties2 = {
        ...baseProperties,
        のし: noshiType,
        _option_group_id: groupId,
        _option_parent: "true",
        _option_mode: "noshi",
        _noshi_type_options: this.dataset.noshiTypeOptions,
        _noshi_heading_options: this.dataset.noshiHeadingOptions
      };
      if (needsNoshi) {
        parentProperties2["上段／表書"] = ((_b = this.noshiHeading) == null ? void 0 : _b.value) || "";
        const senderName = ((_c = this.noshiSender) == null ? void 0 : _c.value.trim()) || "";
        if (senderName) parentProperties2["下段／送り主様のお名前"] = senderName;
      }
      return [{ id: variantId, quantity: 1, properties: parentProperties2 }];
    }
    if (this.optionMode === "gift-card") {
      const giftBoxQuantity = Number(((_d = this.giftBoxSelect) == null ? void 0 : _d.value) || 0);
      const parentProperties2 = {
        ...baseProperties,
        ギフトボックス: giftBoxQuantity === 0 ? "不要" : "1個",
        _option_group_id: groupId,
        _option_parent: "true",
        _option_mode: "gift_card",
        _gift_box_quantity: String(giftBoxQuantity),
        _gift_box_variant_id: this.dataset.giftBoxVariantId
      };
      const items2 = [{ id: variantId, quantity: 1, properties: parentProperties2 }];
      if (giftBoxQuantity > 0) {
        items2.push({
          id: Number(this.dataset.giftBoxVariantId),
          quantity: giftBoxQuantity,
          properties: { _option_group_id: groupId, _option_child: "true", _option_type: "gift_box" }
        });
      }
      return items2;
    }
    const candleValue = ((_e = this.candleSelect) == null ? void 0 : _e.value) || "0";
    const plateQuantity = Number(((_f = this.plateSelect) == null ? void 0 : _f.value) || 0);
    const totalCandleQuantity = candleValue === "more" ? this.freeCandleLimit + this.additionalCandleQuantity : Number(candleValue);
    const messages = this.getMessages();
    const parentProperties = {
      ...baseProperties,
      ロウソク: totalCandleQuantity === 0 ? "不要" : `${totalCandleQuantity}本`,
      メッセージプレート: plateQuantity === 0 ? "不要" : `${plateQuantity}枚`,
      _option_group_id: groupId,
      _option_parent: "true",
      _candle_total_quantity: String(totalCandleQuantity),
      _candle_additional_quantity: candleValue === "more" ? String(this.additionalCandleQuantity) : "0",
      _message_plate_quantity: String(plateQuantity),
      _candle_variant_id: this.dataset.candleVariantId,
      _message_plate_variant_id: this.dataset.messagePlateVariantId
    };
    messages.forEach((message, index) => {
      parentProperties[`メッセージ${index + 1}`] = message;
    });
    const items = [{ id: variantId, quantity: 1, properties: parentProperties }];
    if (candleValue === "more") {
      items.push({
        id: Number(this.dataset.candleVariantId),
        quantity: this.additionalCandleQuantity,
        properties: { _option_group_id: groupId, _option_child: "true", _option_type: "candle" }
      });
    }
    if (plateQuantity > 0) {
      items.push({
        id: Number(this.dataset.messagePlateVariantId),
        quantity: plateQuantity,
        properties: { _option_group_id: groupId, _option_child: "true", _option_type: "message_plate" }
      });
    }
    return items;
  }
  async handleSubmit(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!this.form.checkValidity() || !this.validateMessages()) {
      this.form.reportValidity();
      return;
    }
    const formData = new FormData(this.form);
    const variantId = Number(formData.get("id"));
    const productQuantity = Number(formData.get("quantity") || 1);
    const baseProperties = this.getBaseProperties(formData);
    const items = [];
    for (let index = 0; index < productQuantity; index += 1) {
      items.push(...this.createGroupItems(variantId, baseProperties));
    }
    const submitButtons = [...this.form.querySelectorAll('[type="submit"]')];
    submitButtons.forEach((button) => button.setAttribute("aria-busy", "true"));
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections } }));
    try {
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({ items, sections: sections.join(","), sections_url: window.location.pathname })
      });
      const responseJson = await response.json();
      if (!response.ok) throw new Error(responseJson.description || "カートへの追加に失敗しました。");
      if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
        window.location.href = `${Shopify.routes.root}cart`;
        return;
      }
      const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cart.sections = responseJson.sections;
      this.form.dispatchEvent(new CustomEvent("variant:add", { bubbles: true, detail: { items: responseJson.items, cart } }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", { bubbles: true, detail: { baseEvent: "variant:add", cart } }));
    } catch (error) {
      this.form.dispatchEvent(new CustomEvent("cart:error", { bubbles: true, detail: { error: error.message } }));
    } finally {
      submitButtons.forEach((button) => button.removeAttribute("aria-busy"));
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    }
  }
}
if (!window.customElements.get("original-product-options")) {
  window.customElements.define("original-product-options", OriginalProductOptions);
}
class OriginalDisabledButton extends HTMLElement {
  constructor() {
    super();
    this.observer = new MutationObserver(() => this.syncDisabledState());
  }
  connectedCallback() {
    this.syncDisabledState();
    this.observer.observe(this, {
      attributes: true,
      attributeFilter: ["disabled"],
      childList: true,
      subtree: true
    });
  }
  disconnectedCallback() {
    this.observer.disconnect();
  }
  syncDisabledState() {
    this.querySelectorAll('button[aria-disabled="true"]').forEach((button) => {
      if (!button.disabled) {
        button.disabled = true;
      }
    });
  }
}
if (!window.customElements.get("original-disabled-button")) {
  window.customElements.define("original-disabled-button", OriginalDisabledButton);
}
const _OriginalProductSalesPeriod = class _OriginalProductSalesPeriod extends HTMLElement {
  constructor() {
    super();
    this.abortController = new AbortController();
    this.timeoutId = 0;
  }
  connectedCallback() {
    this.applyState();
    this.scheduleNextUpdate();
    this.bindFormSubmit();
  }
  disconnectedCallback() {
    this.abortController.abort();
    window.clearTimeout(this.timeoutId);
  }
  getState() {
    const nowTimestamp = Math.floor(Date.now() / _OriginalProductSalesPeriod.msPerSecond);
    const startTimestamp = Number(this.dataset.salesStartAt);
    const endTimestamp = Number(this.dataset.salesEndAt);
    if (!Number.isNaN(startTimestamp) && nowTimestamp < startTimestamp) {
      return "before";
    }
    if (!Number.isNaN(endTimestamp) && nowTimestamp >= endTimestamp) {
      return "ended";
    }
    return "active";
  }
  applyState() {
    const state = this.getState();
    const isBeforeStart = state === "before";
    this.hidden = isBeforeStart;
    this.classList.toggle("is-sales-period-before", isBeforeStart);
    if (state !== "ended") {
      return;
    }
    this.querySelectorAll('button[type="submit"], button[type="button"]').forEach((button) => {
      button.disabled = true;
      button.setAttribute("aria-disabled", "true");
      if (this.dataset.endedLabel && button.type === "submit") {
        const label = button.querySelector(".sr-only");
        if (label) {
          label.textContent = this.dataset.endedLabel;
        } else {
          button.textContent = this.dataset.endedLabel;
        }
      }
    });
    this.querySelectorAll(".shopify-payment-button").forEach((element) => {
      element.hidden = true;
    });
  }
  bindFormSubmit() {
    var _a;
    const formId = (_a = this.querySelector("[form]")) == null ? void 0 : _a.getAttribute("form");
    const form = this.closest("form") || document.getElementById(formId);
    form == null ? void 0 : form.addEventListener("submit", (event) => this.guardSubmit(event), {
      capture: true,
      signal: this.abortController.signal
    });
  }
  guardSubmit(event) {
    if (this.getState() === "active") {
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
  }
  scheduleNextUpdate() {
    const nowTimestamp = Math.floor(Date.now() / _OriginalProductSalesPeriod.msPerSecond);
    const startTimestamp = Number(this.dataset.salesStartAt);
    const endTimestamp = Number(this.dataset.salesEndAt);
    let nextTimestamp;
    if (!Number.isNaN(startTimestamp) && nowTimestamp < startTimestamp) {
      nextTimestamp = startTimestamp;
    } else if (!Number.isNaN(endTimestamp) && nowTimestamp < endTimestamp) {
      nextTimestamp = endTimestamp;
    }
    if (nextTimestamp == null) {
      return;
    }
    const delayMs = Math.min(
      Math.max((nextTimestamp - nowTimestamp) * _OriginalProductSalesPeriod.msPerSecond, 0) + _OriginalProductSalesPeriod.stateRecheckBufferMs,
      _OriginalProductSalesPeriod.maxTimeoutMs
    );
    this.timeoutId = window.setTimeout(() => {
      this.applyState();
      this.scheduleNextUpdate();
    }, delayMs);
  }
};
__publicField(_OriginalProductSalesPeriod, "maxTimeoutMs", 2147483647);
__publicField(_OriginalProductSalesPeriod, "stateRecheckBufferMs", 100);
__publicField(_OriginalProductSalesPeriod, "msPerSecond", 1e3);
let OriginalProductSalesPeriod = _OriginalProductSalesPeriod;
if (!window.customElements.get("original-product-sales-period")) {
  window.customElements.define("original-product-sales-period", OriginalProductSalesPeriod);
}
const _OriginalCartSalesPeriod = class _OriginalCartSalesPeriod extends HTMLElement {
  constructor() {
    super();
    this.abortController = new AbortController();
    this.allowCheckout = false;
    this.isRemoving = false;
  }
  connectedCallback() {
    const listenerOptions = {
      capture: true,
      signal: this.abortController.signal
    };
    document.addEventListener("click", (event) => this.handleCheckoutAttempt(event), listenerOptions);
    document.addEventListener("submit", (event) => this.handleCheckoutAttempt(event), listenerOptions);
  }
  disconnectedCallback() {
    this.abortController.abort();
  }
  getCheckoutTrigger(event) {
    var _a;
    if (event.type === "submit") {
      const submitter = event.submitter;
      if ((submitter == null ? void 0 : submitter.matches('[name="checkout"]')) || (submitter == null ? void 0 : submitter.closest(".additional-checkout-buttons, .shopify-payment-button"))) {
        return submitter;
      }
      if (event.target.matches('form[action*="/cart"]') && ((_a = event.submitter) == null ? void 0 : _a.name) === "checkout") {
        return event.submitter;
      }
      return null;
    }
    return event.target.closest(_OriginalCartSalesPeriod.checkoutTriggerSelector);
  }
  getExpiredLineKeys() {
    const nowTimestamp = Math.floor(Date.now() / _OriginalCartSalesPeriod.msPerSecond);
    const expiredKeys = /* @__PURE__ */ new Set();
    document.querySelectorAll(_OriginalCartSalesPeriod.expiredItemSelector).forEach((element) => {
      const endTimestamp = Number(element.dataset.salesEndAt);
      const lineKey = element.dataset.lineKey;
      if (lineKey && !Number.isNaN(endTimestamp) && nowTimestamp >= endTimestamp) {
        expiredKeys.add(lineKey);
      }
    });
    return expiredKeys;
  }
  handleCheckoutAttempt(event) {
    if (this.allowCheckout) {
      return;
    }
    const checkoutTrigger = this.getCheckoutTrigger(event);
    if (!checkoutTrigger) {
      return;
    }
    const expiredKeys = this.getExpiredLineKeys();
    if (expiredKeys.size === 0) {
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (this.isRemoving) {
      return;
    }
    this.removeExpiredItemsAndCheckout(checkoutTrigger, expiredKeys);
  }
  async fetchCart() {
    const response = await fetch(`${Shopify.routes.root}cart.js`);
    if (!response.ok) {
      throw new Error("カート情報の取得に失敗しました。");
    }
    return response.json();
  }
  async updateQuantities(updates) {
    const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates })
    });
    if (!response.ok) {
      throw new Error("販売終了商品の削除に失敗しました。");
    }
    return response.json();
  }
  buildRemovalUpdates(cart, expiredKeys) {
    const updates = {};
    cart.items.forEach((item) => {
      var _a;
      if (!expiredKeys.has(item.key)) {
        return;
      }
      updates[item.key] = 0;
      const groupId = (_a = item.properties) == null ? void 0 : _a._option_group_id;
      if (!groupId) {
        return;
      }
      cart.items.forEach((groupItem) => {
        var _a2;
        if (((_a2 = groupItem.properties) == null ? void 0 : _a2._option_group_id) === groupId) {
          updates[groupItem.key] = 0;
        }
      });
    });
    return updates;
  }
  refreshCart() {
    var _a, _b;
    if (((_b = (_a = window.themeVariables) == null ? void 0 : _a.settings) == null ? void 0 : _b.pageType) === "cart") {
      window.location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent("cart:refresh"));
  }
  async removeExpiredItemsAndCheckout(checkoutTrigger, expiredKeys) {
    this.isRemoving = true;
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    try {
      const cart = await this.fetchCart();
      const updates = this.buildRemovalUpdates(cart, expiredKeys);
      const nextCart = Object.keys(updates).length > 0 ? await this.updateQuantities(updates) : cart;
      const removedMessage = this.dataset.removedMessage;
      if (removedMessage) {
        window.alert(removedMessage);
      }
      if (nextCart.item_count === 0) {
        this.refreshCart();
        return;
      }
      this.allowCheckout = true;
      checkoutTrigger.click();
    } catch (error) {
      window.alert(error.message);
    } finally {
      this.allowCheckout = false;
      this.isRemoving = false;
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    }
  }
};
__publicField(_OriginalCartSalesPeriod, "checkoutTriggerSelector", '[name="checkout"], .shopify-payment-button button, .additional-checkout-buttons');
__publicField(_OriginalCartSalesPeriod, "expiredItemSelector", ".js-cart-sales-period-item[data-sales-end-at]");
__publicField(_OriginalCartSalesPeriod, "msPerSecond", 1e3);
let OriginalCartSalesPeriod = _OriginalCartSalesPeriod;
if (!window.customElements.get("original-cart-sales-period")) {
  window.customElements.define("original-cart-sales-period", OriginalCartSalesPeriod);
}
class OriginalCartProductOptions extends HTMLElement {
  constructor() {
    super();
    this.abortController = new AbortController();
  }
  connectedCallback() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    this.optionMode = this.dataset.optionMode || "cake";
    this.dialog = this.querySelector(".js-cart-options-dialog");
    this.form = this.querySelector(".js-cart-options-form");
    this.noshiSelect = this.querySelector(".js-cart-options-noshi-select");
    this.noshiDetail = this.querySelector(".js-cart-options-noshi-detail");
    this.noshiHeading = this.querySelector(".js-cart-options-noshi-heading");
    this.noshiSender = this.querySelector(".js-cart-options-noshi-sender");
    this.candleSelect = this.querySelector(".js-cart-options-candle-select");
    this.candleQuantity = this.querySelector(".js-cart-options-candle-quantity");
    this.plateSelect = this.querySelector(".js-cart-options-plate-select");
    this.giftBoxSelect = this.querySelector(".js-cart-options-gift-box-select");
    this.giftBoxDetail = this.querySelector(".js-cart-options-gift-box-detail");
    this.messageFields = [...this.querySelectorAll(".js-cart-options-message")];
    this.panels = [...this.querySelectorAll(".js-cart-options-panel")];
    this.errorMessage = this.querySelector(".js-cart-options-error");
    const parsedProperties = JSON.parse(((_a = this.querySelector(".js-cart-options-properties")) == null ? void 0 : _a.textContent) || "{}");
    this.properties = Array.isArray(parsedProperties) ? Object.fromEntries(parsedProperties) : parsedProperties;
    this.querySelectorAll(".js-cart-options-open").forEach((button) => {
      button.addEventListener("click", () => this.openDialog(button.dataset.optionType), { signal: this.abortController.signal });
    });
    this.querySelectorAll(".js-cart-options-close").forEach((button) => {
      button.addEventListener("click", () => this.dialog.close(), { signal: this.abortController.signal });
    });
    (_b = this.candleSelect) == null ? void 0 : _b.addEventListener("change", () => this.updateFields(), { signal: this.abortController.signal });
    (_c = this.candleQuantity) == null ? void 0 : _c.addEventListener("input", () => this.updateCandleSummary(), { signal: this.abortController.signal });
    (_d = this.querySelector(".js-cart-options-candle-minus")) == null ? void 0 : _d.addEventListener("click", () => this.changeCandleQuantity(-1), { signal: this.abortController.signal });
    (_e = this.querySelector(".js-cart-options-candle-plus")) == null ? void 0 : _e.addEventListener("click", () => this.changeCandleQuantity(1), { signal: this.abortController.signal });
    (_f = this.plateSelect) == null ? void 0 : _f.addEventListener("change", () => this.updateFields(), { signal: this.abortController.signal });
    (_g = this.giftBoxSelect) == null ? void 0 : _g.addEventListener("change", () => this.updateFields(), { signal: this.abortController.signal });
    (_h = this.noshiSelect) == null ? void 0 : _h.addEventListener("change", () => this.updateFields(), { signal: this.abortController.signal });
    (_i = this.noshiSender) == null ? void 0 : _i.addEventListener("input", () => this.updateNoshiCharacterCount(), { signal: this.abortController.signal });
    (_j = this.querySelector(".js-cart-options-save")) == null ? void 0 : _j.addEventListener("click", (event) => this.save(event), { signal: this.abortController.signal });
    this.updateFields();
  }
  disconnectedCallback() {
    this.abortController.abort();
  }
  openDialog(optionType) {
    if (optionType === "noshi") {
      this.querySelector(".js-cart-options-title").textContent = "のし";
      this.querySelector(".js-cart-options-note").textContent = "";
      this.showError("");
      this.dialog.showModal();
      return;
    }
    if (optionType === "gift-box") {
      this.querySelector(".js-cart-options-title").textContent = "ギフトボックス";
      this.querySelector(".js-cart-options-note").textContent = "";
      this.showError("");
      this.dialog.showModal();
      return;
    }
    const isCandle = optionType === "candle";
    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.optionPanel !== optionType;
    });
    this.querySelector(".js-cart-options-title").textContent = isCandle ? "ロウソク（3本まで無料）" : "メッセージプレート（最大2枚）";
    this.querySelector(".js-cart-options-note").textContent = isCandle ? "※カラーはお選びいただけません" : "メッセージは1枚につき20文字まで入力できます";
    this.showError("");
    this.dialog.showModal();
  }
  showError(message) {
    if (!this.errorMessage) return;
    this.errorMessage.textContent = message;
    this.errorMessage.hidden = message === "";
  }
  changeCandleQuantity(amount) {
    const quantity = Math.max(1, Number(this.candleQuantity.value || 1) + amount);
    this.candleQuantity.value = quantity;
    this.updateCandleSummary();
  }
  updateCandleSummary() {
    const additionalQuantity = Math.max(1, Number(this.candleQuantity.value || 1));
    this.candleQuantity.value = additionalQuantity;
    this.querySelector(".js-cart-options-candle-total").textContent = 3 + additionalQuantity;
    this.querySelector(".js-cart-options-candle-subtotal").textContent = this.formatMoney(Number(this.dataset.candlePrice || 0) * additionalQuantity);
  }
  formatMoney(price) {
    const amount = price / 100;
    const formattedPrice = new Intl.NumberFormat("ja-JP", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
    const formattedPriceWithoutDecimals = new Intl.NumberFormat("ja-JP", { maximumFractionDigits: 0 }).format(amount);
    return this.dataset.moneyFormat.replace(/\{\{\s*amount_no_decimals\s*\}\}/, formattedPriceWithoutDecimals).replace(/\{\{\s*amount\s*\}\}/, formattedPrice);
  }
  updateFields() {
    var _a, _b;
    if (this.optionMode === "noshi") {
      const needsNoshi = ((_a = this.noshiSelect) == null ? void 0 : _a.value) !== "不要";
      if (this.noshiDetail) this.noshiDetail.hidden = !needsNoshi;
      if (this.noshiHeading) this.noshiHeading.disabled = !needsNoshi;
      if (this.noshiSender) this.noshiSender.disabled = !needsNoshi;
      return;
    }
    if (this.optionMode === "gift-card") {
      if (this.giftBoxDetail) this.giftBoxDetail.hidden = ((_b = this.giftBoxSelect) == null ? void 0 : _b.value) !== "1";
      return;
    }
    const usesPaidCandles = this.candleSelect.value === "more";
    this.querySelector(".js-cart-options-candle-additional").hidden = !usesPaidCandles;
    this.candleQuantity.required = usesPaidCandles;
    if (usesPaidCandles) this.updateCandleSummary();
    const plateQuantity = Number(this.plateSelect.value);
    this.messageFields.forEach((field, index) => {
      const input = field.querySelector("textarea");
      field.hidden = index >= plateQuantity;
      input.required = index < plateQuantity;
      if (index >= plateQuantity) input.value = "";
    });
  }
  updateNoshiCharacterCount() {
    var _a;
    const characterCount = this.querySelector(".js-cart-options-noshi-character-count");
    if (characterCount) characterCount.textContent = [...((_a = this.noshiSender) == null ? void 0 : _a.value) || ""].length;
  }
  async changeLine(key, quantity, properties) {
    if (!key && quantity === 0) return;
    const body = { id: key, quantity };
    if (properties) body.properties = properties;
    const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    });
    if (!response.ok) {
      const responseJson = await response.json();
      throw new Error(responseJson.description || responseJson.message || "オプションの更新に失敗しました。");
    }
  }
  async addChild(variantId, quantity, optionType, groupId) {
    if (!variantId || quantity === 0) return;
    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity, properties: { _option_group_id: groupId, _option_child: "true", _option_type: optionType } }]
      })
    });
    if (!response.ok) {
      const responseJson = await response.json();
      throw new Error(responseJson.description || responseJson.message || "オプション商品の追加に失敗しました。");
    }
  }
  async getCurrentGroup(groupId) {
    var _a;
    const response = await fetch(`${Shopify.routes.root}cart.js`);
    if (!response.ok) throw new Error("カート情報の取得に失敗しました。");
    const cart = await response.json();
    const parentByKey = cart.items.find((item) => item.key === this.dataset.parentKey);
    const currentGroupId = groupId || ((_a = parentByKey == null ? void 0 : parentByKey.properties) == null ? void 0 : _a._option_group_id);
    const groupItems = cart.items.filter((item) => {
      var _a2;
      return String((_a2 = item.properties) == null ? void 0 : _a2._option_group_id) === String(currentGroupId);
    });
    return {
      groupId: currentGroupId,
      parent: groupItems.find((item) => {
        var _a2;
        return ((_a2 = item.properties) == null ? void 0 : _a2._option_child) !== "true";
      }) || parentByKey,
      candle: groupItems.find((item) => {
        var _a2;
        return ((_a2 = item.properties) == null ? void 0 : _a2._option_type) === "candle";
      }),
      plate: groupItems.find((item) => {
        var _a2;
        return ((_a2 = item.properties) == null ? void 0 : _a2._option_type) === "message_plate";
      }),
      giftBox: groupItems.find((item) => {
        var _a2;
        return ((_a2 = item.properties) == null ? void 0 : _a2._option_type) === "gift_box";
      })
    };
  }
  async save(event) {
    event.preventDefault();
    this.showError("");
    const invalidField = this.form.querySelector(":invalid");
    if (invalidField) {
      invalidField.reportValidity();
      return;
    }
    if (this.optionMode === "noshi") {
      await this.saveNoshi();
      return;
    }
    if (this.optionMode === "gift-card") {
      await this.saveGiftBox();
      return;
    }
    const candleValue = this.candleSelect.value;
    const additionalCandleQuantity = candleValue === "more" ? Number(this.candleQuantity.value) : 0;
    const candleTotalQuantity = candleValue === "more" ? 3 + additionalCandleQuantity : Number(candleValue);
    const plateQuantity = Number(this.plateSelect.value);
    const messages = this.messageFields.slice(0, plateQuantity).map((field) => field.querySelector("textarea").value.trim());
    const groupId = this.dataset.optionGroupId || this.properties._option_group_id;
    this.properties._option_group_id = groupId;
    this.properties._option_parent = "true";
    this.properties.ロウソク = candleTotalQuantity === 0 ? "不要" : `${candleTotalQuantity}本`;
    this.properties.メッセージプレート = plateQuantity === 0 ? "不要" : `${plateQuantity}枚`;
    this.properties._candle_total_quantity = String(candleTotalQuantity);
    this.properties._candle_additional_quantity = String(additionalCandleQuantity);
    this.properties._message_plate_quantity = String(plateQuantity);
    delete this.properties.メッセージ1;
    delete this.properties.メッセージ2;
    messages.forEach((message, index) => {
      this.properties[`メッセージ${index + 1}`] = message;
    });
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    try {
      const currentGroup = await this.getCurrentGroup(groupId);
      if (!currentGroup.parent) throw new Error("更新対象の商品がカート内に見つかりません。");
      const currentGroupId = currentGroup.groupId || groupId;
      const parentQuantity = currentGroup.parent.quantity;
      this.properties._option_group_id = currentGroupId;
      await this.changeLine(currentGroup.parent.key, parentQuantity, this.properties);
      if (currentGroup.candle) {
        await this.changeLine(currentGroup.candle.key, additionalCandleQuantity * parentQuantity);
      } else {
        await this.addChild(this.dataset.candleVariantId, additionalCandleQuantity * parentQuantity, "candle", currentGroupId);
      }
      if (currentGroup.plate) {
        await this.changeLine(currentGroup.plate.key, plateQuantity * parentQuantity);
      } else {
        await this.addChild(this.dataset.plateVariantId, plateQuantity * parentQuantity, "message_plate", currentGroupId);
      }
      this.refreshCart();
    } catch (error) {
      this.showError(error.message);
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    }
  }
  async saveNoshi() {
    var _a, _b, _c;
    const noshiType = ((_a = this.noshiSelect) == null ? void 0 : _a.value) || "不要";
    const groupId = this.dataset.optionGroupId || this.properties._option_group_id;
    this.properties._option_group_id = groupId;
    this.properties._option_parent = "true";
    this.properties._option_mode = "noshi";
    this.properties.のし = noshiType;
    delete this.properties["上段／表書"];
    delete this.properties["下段／送り主様のお名前"];
    if (noshiType !== "不要") {
      this.properties["上段／表書"] = ((_b = this.noshiHeading) == null ? void 0 : _b.value) || "";
      const senderName = ((_c = this.noshiSender) == null ? void 0 : _c.value.trim()) || "";
      if (senderName) this.properties["下段／送り主様のお名前"] = senderName;
    }
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    try {
      const currentGroup = await this.getCurrentGroup(groupId);
      if (!currentGroup.parent) throw new Error("更新対象の商品がカート内に見つかりません。");
      await this.changeLine(currentGroup.parent.key, currentGroup.parent.quantity, this.properties);
      this.refreshCart();
    } catch (error) {
      this.showError(error.message);
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    }
  }
  async saveGiftBox() {
    var _a;
    const giftBoxQuantity = Number(((_a = this.giftBoxSelect) == null ? void 0 : _a.value) || 0);
    const groupId = this.dataset.optionGroupId || this.properties._option_group_id;
    this.properties._option_group_id = groupId;
    this.properties._option_parent = "true";
    this.properties._option_mode = "gift_card";
    this.properties.ギフトボックス = giftBoxQuantity === 0 ? "不要" : "1個";
    this.properties._gift_box_quantity = String(giftBoxQuantity);
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    try {
      const currentGroup = await this.getCurrentGroup(groupId);
      if (!currentGroup.parent) throw new Error("更新対象の商品がカート内に見つかりません。");
      const currentGroupId = currentGroup.groupId || groupId;
      const parentQuantity = currentGroup.parent.quantity;
      this.properties._option_group_id = currentGroupId;
      await this.changeLine(currentGroup.parent.key, parentQuantity, this.properties);
      if (currentGroup.giftBox) {
        await this.changeLine(currentGroup.giftBox.key, giftBoxQuantity * parentQuantity);
      } else {
        await this.addChild(this.dataset.giftBoxVariantId, giftBoxQuantity * parentQuantity, "gift_box", currentGroupId);
      }
      this.refreshCart();
    } catch (error) {
      this.showError(error.message);
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    }
  }
  refreshCart() {
    if (window.themeVariables.settings.pageType === "cart") {
      window.location.reload();
    } else {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      this.dialog.close();
    }
  }
}
class OriginalOptionGroupQuantity extends HTMLElement {
  connectedCallback() {
    var _a, _b, _c;
    (_a = this.querySelector(".js-option-group-clone")) == null ? void 0 : _a.addEventListener("click", () => this.changeGroupQuantity(1));
    (_b = this.querySelector(".js-option-group-decrease")) == null ? void 0 : _b.addEventListener("click", () => this.changeGroupQuantity(-1));
    (_c = this.querySelector(".js-option-group-remove")) == null ? void 0 : _c.addEventListener("click", () => this.removeGroup());
  }
  async getGroup() {
    const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    const parent = cart.items.find((item) => item.key === this.dataset.parentKey);
    if (!parent) throw new Error("対象の商品が見つかりません。");
    const groupId = parent.properties._option_group_id;
    const groupItems = cart.items.filter((item) => {
      var _a;
      return ((_a = item.properties) == null ? void 0 : _a._option_group_id) === groupId;
    });
    return {
      parent,
      candle: groupItems.find((item) => {
        var _a;
        return ((_a = item.properties) == null ? void 0 : _a._option_type) === "candle";
      }),
      plate: groupItems.find((item) => {
        var _a;
        return ((_a = item.properties) == null ? void 0 : _a._option_type) === "message_plate";
      }),
      giftBox: groupItems.find((item) => {
        var _a;
        return ((_a = item.properties) == null ? void 0 : _a._option_type) === "gift_box";
      }),
      items: groupItems
    };
  }
  async updateQuantities(updates) {
    const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates })
    });
    if (!response.ok) throw new Error("商品の数量変更に失敗しました。");
  }
  async changeGroupQuantity(amount) {
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    try {
      const group = await this.getGroup();
      const nextQuantity = Math.max(0, group.parent.quantity + amount);
      const candleQuantityPerItem = Number(group.parent.properties._candle_additional_quantity || 0);
      const plateQuantityPerItem = Number(group.parent.properties._message_plate_quantity || 0);
      const giftBoxQuantityPerItem = Number(group.parent.properties._gift_box_quantity || 0);
      const updates = { [group.parent.key]: nextQuantity };
      if (group.candle) updates[group.candle.key] = candleQuantityPerItem * nextQuantity;
      if (group.plate) updates[group.plate.key] = plateQuantityPerItem * nextQuantity;
      if (group.giftBox) updates[group.giftBox.key] = giftBoxQuantityPerItem * nextQuantity;
      await this.updateQuantities(updates);
      this.refreshCart();
    } catch (error) {
      window.alert(error.message);
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    }
  }
  async removeGroup() {
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    try {
      const group = await this.getGroup();
      const updates = Object.fromEntries(group.items.map((item) => [item.key, 0]));
      await this.updateQuantities(updates);
      this.refreshCart();
    } catch (error) {
      window.alert(error.message);
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    }
  }
  refreshCart() {
    if (window.themeVariables.settings.pageType === "cart") window.location.reload();
    else document.dispatchEvent(new CustomEvent("cart:refresh"));
  }
}
if (!window.customElements.get("original-cart-product-options")) {
  window.customElements.define("original-cart-product-options", OriginalCartProductOptions);
}
if (!window.customElements.get("original-option-group-quantity")) {
  window.customElements.define("original-option-group-quantity", OriginalOptionGroupQuantity);
}
const updateVisibleCartCount = (cart) => {
  const visibleCount = cart.items.filter((item) => {
    var _a;
    return ((_a = item.properties) == null ? void 0 : _a._option_child) !== "true";
  }).reduce((count, item) => count + item.quantity, 0);
  document.querySelectorAll("cart-count").forEach((element) => {
    element.textContent = visibleCount;
  });
};
document.addEventListener("cart:change", (event) => updateVisibleCartCount(event.detail.cart));
document.addEventListener("cart:refresh", async () => {
  const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
  updateVisibleCartCount(cart);
});
class OriginalCartShoppingBag extends HTMLElement {
  constructor() {
    super();
    this.abortController = new AbortController();
  }
  connectedCallback() {
    var _a;
    this.dialog = this.querySelector(".js-cart-shopping-bag-dialog");
    this.errorMessage = this.querySelector(".js-cart-shopping-bag-error");
    (_a = this.querySelector(".js-cart-shopping-bag-open")) == null ? void 0 : _a.addEventListener("click", () => this.dialog.showModal(), { signal: this.abortController.signal });
    this.querySelectorAll(".js-cart-shopping-bag-close").forEach((button) => {
      button.addEventListener("click", () => this.dialog.close(), { signal: this.abortController.signal });
    });
    this.querySelectorAll(".js-cart-shopping-bag-add").forEach((button) => {
      button.addEventListener("click", () => this.addVariant(button), { signal: this.abortController.signal });
    });
    this.querySelectorAll(".p-cart-shopping-bag__item").forEach((item) => {
      var _a2, _b, _c;
      (_a2 = item.querySelector(".js-cart-shopping-bag-minus")) == null ? void 0 : _a2.addEventListener("click", () => this.changeLine(item, -1), { signal: this.abortController.signal });
      (_b = item.querySelector(".js-cart-shopping-bag-plus")) == null ? void 0 : _b.addEventListener("click", () => this.changeLine(item, 1), { signal: this.abortController.signal });
      (_c = item.querySelector(".js-cart-shopping-bag-remove")) == null ? void 0 : _c.addEventListener("click", () => this.removeLine(item), { signal: this.abortController.signal });
    });
  }
  disconnectedCallback() {
    this.abortController.abort();
  }
  showError(message) {
    if (!this.errorMessage) return;
    this.errorMessage.textContent = message;
    this.errorMessage.hidden = message === "";
  }
  async request(url, body) {
    const response = await fetch(`${Shopify.routes.root}${url}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    });
    const responseJson = await response.json();
    if (!response.ok) throw new Error(responseJson.description || responseJson.message || "手提げ袋の更新に失敗しました。");
  }
  async addVariant(button) {
    this.showError("");
    button.setAttribute("aria-busy", "true");
    try {
      await this.request("cart/add.js", { items: [{ id: Number(button.dataset.variantId), quantity: 1 }] });
      window.location.reload();
    } catch (error) {
      this.showError(error.message);
      button.removeAttribute("aria-busy");
    }
  }
  async changeLine(item, amount) {
    const currentQuantity = Number(item.querySelector(".p-cart-shopping-bag__quantity span").textContent);
    await this.updateLine(item.dataset.lineKey, Math.max(0, currentQuantity + amount));
  }
  async removeLine(item) {
    await this.updateLine(item.dataset.lineKey, 0);
  }
  async updateLine(key, quantity) {
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    try {
      await this.request("cart/change.js", { id: key, quantity });
      window.location.reload();
    } catch (error) {
      this.showError(error.message);
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    }
  }
}
if (!window.customElements.get("original-cart-shopping-bag")) {
  window.customElements.define("original-cart-shopping-bag", OriginalCartShoppingBag);
}
class OriginalCartMessageCard extends HTMLElement {
  constructor() {
    super();
    this.abortController = new AbortController();
    this.savePromise = Promise.resolve();
  }
  connectedCallback() {
    var _a, _b, _c, _d;
    this.select = this.querySelector(".js-cart-message-card-select");
    this.images = [...this.querySelectorAll(".js-cart-message-card-image")];
    this.description = this.querySelector(".js-cart-message-card-description");
    this.freeMessageWrap = this.querySelector(".js-cart-message-card-free-message");
    this.freeMessageTextarea = this.querySelector(".js-cart-message-card-free-message-textarea");
    this.freeMessageCounter = this.querySelector(".js-cart-message-card-free-message-counter");
    this.error = this.querySelector(".js-cart-message-card-error");
    this.freeInputValues = new Set(
      [...((_a = this.select) == null ? void 0 : _a.querySelectorAll('option[data-free-input="true"]')) ?? []].map((option) => option.value)
    );
    const { signal } = this.abortController;
    (_b = this.select) == null ? void 0 : _b.addEventListener("change", () => this.handleSelectChange(), { signal });
    (_c = this.freeMessageTextarea) == null ? void 0 : _c.addEventListener("input", () => this.updateCounter(), { signal });
    (_d = this.freeMessageTextarea) == null ? void 0 : _d.addEventListener("blur", () => this.handleFreeMessageBlur(), { signal });
    this.updateVisibility();
    this.updateCounter();
  }
  disconnectedCallback() {
    this.abortController.abort();
  }
  isFreeMessageSelected() {
    var _a;
    return this.freeInputValues.has(((_a = this.select) == null ? void 0 : _a.value) || "");
  }
  updateVisibility() {
    var _a;
    const selectedValue = ((_a = this.select) == null ? void 0 : _a.value) || "";
    const isFreeMessage = this.isFreeMessageSelected();
    this.classList.toggle("is-selected", selectedValue !== "");
    this.images.forEach((image) => {
      image.hidden = image.dataset.cardValue !== selectedValue;
    });
    if (this.description) this.description.hidden = isFreeMessage;
    if (this.freeMessageWrap) this.freeMessageWrap.hidden = !isFreeMessage;
  }
  updateCounter() {
    if (!this.freeMessageCounter || !this.freeMessageTextarea) return;
    const characterCount = this.freeMessageTextarea.value.length;
    this.freeMessageCounter.textContent = `${characterCount}/${this.freeMessageTextarea.maxLength}`;
  }
  showError(message) {
    if (!this.error) return;
    this.error.textContent = message;
    this.error.hidden = message === "";
  }
  handleSelectChange() {
    this.updateVisibility();
    this.showError("");
    this.queueSave().catch((error) => this.showError(error.message));
  }
  handleFreeMessageBlur() {
    this.queueSave().catch((error) => this.showError(error.message));
  }
  /** 保存処理を直列化し、古い入力値による上書きを防ぐ */
  queueSave() {
    this.savePromise = this.savePromise.catch(() => {
    }).then(() => this.save());
    return this.savePromise;
  }
  async save() {
    const selectedValue = this.select.value;
    const messageCardBody = this.isFreeMessageSelected() ? this.freeMessageTextarea.value : "";
    const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { メッセージカード: selectedValue, メッセージカード本文: messageCardBody } })
    });
    const responseJson = await response.json();
    if (!response.ok) throw new Error(responseJson.description || responseJson.message || "メッセージカードの保存に失敗しました。");
    this.showError("");
  }
}
if (!window.customElements.get("original-cart-message-card")) {
  window.customElements.define("original-cart-message-card", OriginalCartMessageCard);
}
const _OriginalCartDeliveryValidator = class _OriginalCartDeliveryValidator extends HTMLElement {
  constructor() {
    super();
    this.abortController = new AbortController();
    this.observer = new MutationObserver(() => this.syncCheckoutButtonState());
  }
  connectedCallback() {
    var _a, _b;
    this.form = this.querySelector("form");
    this.checkoutButton = this.querySelector(_OriginalCartDeliveryValidator.checkoutButtonSelector);
    this.error = this.querySelector(".js-cart-delivery-error");
    (_a = this.form) == null ? void 0 : _a.addEventListener("submit", (event) => this.validate(event), { signal: this.abortController.signal });
    (_b = this.checkoutButton) == null ? void 0 : _b.addEventListener("click", (event) => this.validate(event), { signal: this.abortController.signal });
    this.addEventListener("input", () => this.syncCheckoutButtonState(), { signal: this.abortController.signal });
    this.addEventListener("change", () => this.syncCheckoutButtonState(), { signal: this.abortController.signal });
    this.addEventListener("click", () => requestAnimationFrame(() => this.syncCheckoutButtonState()), { signal: this.abortController.signal });
    this.observer.observe(this, {
      attributes: true,
      attributeFilter: ["value"],
      childList: true,
      subtree: true
    });
    this.syncCheckoutButtonState();
  }
  disconnectedCallback() {
    this.abortController.abort();
    this.observer.disconnect();
  }
  getDateInput() {
    const dateInputs = [...this.querySelectorAll(_OriginalCartDeliveryValidator.dateInputSelector)];
    return dateInputs.find((dateInput) => dateInput.offsetParent !== null) || dateInputs[0];
  }
  clearError() {
    const dateInput = this.getDateInput();
    dateInput == null ? void 0 : dateInput.removeAttribute("aria-invalid");
    if (this.error) {
      this.error.textContent = "";
      this.error.hidden = true;
    }
  }
  syncCheckoutButtonState() {
    var _a;
    const hasSelectedDate = Boolean((_a = this.getDateInput()) == null ? void 0 : _a.value.trim());
    if (this.checkoutButton) {
      this.checkoutButton.disabled = !hasSelectedDate;
      this.checkoutButton.setAttribute("aria-disabled", String(!hasSelectedDate));
    }
    if (hasSelectedDate) {
      this.clearError();
    }
  }
  validate(event) {
    var _a;
    const dateInput = this.getDateInput();
    if (dateInput == null ? void 0 : dateInput.value.trim()) {
      this.clearError();
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    dateInput == null ? void 0 : dateInput.setAttribute("aria-invalid", "true");
    if (this.error) {
      this.error.textContent = _OriginalCartDeliveryValidator.errorMessage;
      this.error.hidden = false;
    }
    (_a = dateInput == null ? void 0 : dateInput.closest('[role="combobox"]')) == null ? void 0 : _a.focus();
  }
};
__publicField(_OriginalCartDeliveryValidator, "dateInputSelector", "#Zapiet-InputCalendar__shipping, #Zapiet-InputCalendar__pickup");
__publicField(_OriginalCartDeliveryValidator, "checkoutButtonSelector", '[name="checkout"]');
__publicField(_OriginalCartDeliveryValidator, "errorMessage", "受取・配送日時を選択してから、ご購入手続きへお進みください。");
let OriginalCartDeliveryValidator = _OriginalCartDeliveryValidator;
if (!window.customElements.get("original-cart-delivery-validator")) {
  window.customElements.define("original-cart-delivery-validator", OriginalCartDeliveryValidator);
}
class OriginalCollectionSort extends HTMLElement {
  connectedCallback() {
    var _a;
    this.select = this.querySelector(".js-collection-sort-select");
    this.handleChange = this.handleChange.bind(this);
    (_a = this.select) == null ? void 0 : _a.addEventListener("change", this.handleChange);
  }
  disconnectedCallback() {
    var _a;
    (_a = this.select) == null ? void 0 : _a.removeEventListener("change", this.handleChange);
  }
  handleChange() {
    var _a, _b;
    (_b = (_a = this.select) == null ? void 0 : _a.form) == null ? void 0 : _b.requestSubmit();
  }
}
if (!customElements.get("original-collection-sort")) {
  customElements.define("original-collection-sort", OriginalCollectionSort);
}
class OriginalContactForm extends HTMLElement {
  connectedCallback() {
    var _a;
    this.form = this.querySelector("form");
    this.email = this.querySelector("#contact-email");
    this.emailConfirm = this.querySelector("[data-email-confirm]");
    this.emailError = this.querySelector("[data-email-error]");
    (_a = this.form) == null ? void 0 : _a.addEventListener("submit", (event) => this.validate(event));
    const status = this.querySelector("[data-contact-status]");
    if (status) {
      requestAnimationFrame(() => status.focus());
    }
  }
  validate(event) {
    var _a, _b, _c, _d;
    const emailMatches = ((_a = this.email) == null ? void 0 : _a.value) === ((_b = this.emailConfirm) == null ? void 0 : _b.value);
    if (!emailMatches) {
      event.preventDefault();
      this.emailConfirm.setCustomValidity("メールアドレスが一致しません。");
      this.emailConfirm.setAttribute("aria-invalid", "true");
      this.emailError.hidden = false;
      this.emailConfirm.focus();
      return;
    }
    (_c = this.emailConfirm) == null ? void 0 : _c.setCustomValidity("");
    (_d = this.emailConfirm) == null ? void 0 : _d.removeAttribute("aria-invalid");
    this.emailError.hidden = true;
    if (!this.form.checkValidity()) {
      event.preventDefault();
      this.form.reportValidity();
    }
  }
}
if (!customElements.get("original-contact-form")) {
  customElements.define("original-contact-form", OriginalContactForm);
}
const MINIMUM_SLIDE_COUNT_MOBILE = 2;
const MINIMUM_SLIDE_COUNT_DESKTOP = 3;
const DESKTOP_MEDIA_QUERY$1 = "(min-width: 750px)";
const DUPLICATE_SLIDE_CLASS = "js-shop-detail-hero-duplicate";
const AUTOPLAY_DELAY = 5e3;
const TRANSITION_SPEED = 900;
class OriginalShopDetailHero extends HTMLElement {
  connectedCallback() {
    var _a;
    this.removeDuplicateSlides();
    this.slider = this.querySelector(".js-shop-detail-hero-slider");
    this.slides = [...this.querySelectorAll(".swiper-slide")];
    this.pagination = this.querySelector(".js-shop-detail-hero-pagination");
    this.paginationBullets = [...this.querySelectorAll(".js-shop-detail-hero-pagination-bullet")];
    if (!this.slider || this.slides.length < MINIMUM_SLIDE_COUNT_MOBILE || this.swiper) {
      return;
    }
    this.slides.forEach((slide, index) => {
      slide.dataset.slideIndex = String(index);
    });
    this.handlePaginationClick = this.handlePaginationClick.bind(this);
    this.handleViewportChange = this.handleViewportChange.bind(this);
    (_a = this.pagination) == null ? void 0 : _a.addEventListener("click", this.handlePaginationClick);
    this.desktopMediaQuery = window.matchMedia(DESKTOP_MEDIA_QUERY$1);
    this.desktopMediaQuery.addEventListener("change", this.handleViewportChange);
    loadSwiper().then(() => {
      if (!this.isConnected || this.swiper) {
        return;
      }
      this.updateSliderState();
    });
  }
  disconnectedCallback() {
    var _a, _b;
    (_a = this.pagination) == null ? void 0 : _a.removeEventListener("click", this.handlePaginationClick);
    (_b = this.desktopMediaQuery) == null ? void 0 : _b.removeEventListener("change", this.handleViewportChange);
    this.destroySwiper();
    this.removeDuplicateSlides();
  }
  /** 画面幅ごとの必要枚数に応じてSwiperの有効・無効を切り替える */
  handleViewportChange() {
    this.updateSliderState();
  }
  /** SPは2枚以上、PCは3枚以上の場合にSwiperを初期化する */
  updateSliderState() {
    const minimumSlideCount = this.desktopMediaQuery.matches ? MINIMUM_SLIDE_COUNT_DESKTOP : MINIMUM_SLIDE_COUNT_MOBILE;
    if (this.slides.length >= minimumSlideCount) {
      if (!this.swiper) {
        this.removeDuplicateSlides();
        this.appendDuplicateSlides();
        this.initSwiper();
      }
      return;
    }
    this.destroySwiper();
    this.removeDuplicateSlides();
  }
  /** Swiperを破棄し、固定レイアウトへ戻す */
  destroySwiper() {
    if (!this.swiper) {
      return;
    }
    this.swiper.destroy(true, true);
    this.swiper = null;
  }
  initSwiper() {
    this.swiper = new window.Swiper(this.slider, {
      autoplay: {
        delay: AUTOPLAY_DELAY,
        disableOnInteraction: false
      },
      breakpoints: {
        750: {
          slidesPerView: "auto"
        }
      },
      centeredSlides: true,
      grabCursor: true,
      initialSlide: 1,
      loop: true,
      on: {
        init: (swiper) => this.updatePagination(swiper),
        slideChange: (swiper) => this.updatePagination(swiper)
      },
      slidesPerView: 1,
      speed: TRANSITION_SPEED,
      watchOverflow: true
    });
  }
  /** ループに必要な枚数を確保するため、表示画像を内部用に複製する */
  appendDuplicateSlides() {
    const track = this.slider.querySelector(".swiper-wrapper");
    this.slides.forEach((slide) => {
      const duplicateSlide = slide.cloneNode(true);
      duplicateSlide.classList.add(DUPLICATE_SLIDE_CLASS);
      duplicateSlide.setAttribute("aria-hidden", "true");
      track.appendChild(duplicateSlide);
    });
  }
  /** 切断・再接続時に内部複製したスライドを取り除く */
  removeDuplicateSlides() {
    this.querySelectorAll(`.${DUPLICATE_SLIDE_CLASS}`).forEach((slide) => slide.remove());
  }
  /** クリックしたドットに対応する最寄りのスライドへ移動する */
  handlePaginationClick(event) {
    var _a;
    const bullet = event.target.closest(".js-shop-detail-hero-pagination-bullet");
    if (!bullet || !((_a = this.pagination) == null ? void 0 : _a.contains(bullet)) || !this.swiper) {
      return;
    }
    const targetSlideIndex = Number(bullet.dataset.slideIndex);
    const closestSlideIndex = [...this.swiper.slides].reduce((closestIndex, slide, index) => {
      if (Number(slide.dataset.slideIndex) !== targetSlideIndex) {
        return closestIndex;
      }
      return Math.abs(index - this.swiper.activeIndex) < Math.abs(closestIndex - this.swiper.activeIndex) ? index : closestIndex;
    }, Number.POSITIVE_INFINITY);
    if (Number.isFinite(closestSlideIndex)) {
      this.swiper.slideTo(closestSlideIndex);
    }
  }
  /** アクティブな画像とドットの状態を同期する */
  updatePagination(swiper) {
    var _a;
    const activeSlideIndex = Number((_a = swiper.slides[swiper.activeIndex]) == null ? void 0 : _a.dataset.slideIndex);
    this.paginationBullets.forEach((bullet) => {
      const isActive = Number(bullet.dataset.slideIndex) === activeSlideIndex;
      bullet.classList.toggle("swiper-pagination-bullet-active", isActive);
      bullet.toggleAttribute("aria-current", isActive);
    });
  }
}
if (!customElements.get("original-shop-detail-hero")) {
  customElements.define("original-shop-detail-hero", OriginalShopDetailHero);
}
const DESKTOP_BREAKPOINT = 750;
class OriginalGiftCardSlider extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector(".js-gift-card-slider");
    this.list = this.querySelector(".js-gift-card-list");
    this.slides = [...this.querySelectorAll(".js-gift-card-slide")];
    this.pagination = this.querySelector(".js-gift-card-pagination");
    this.buttonPrevious = this.querySelector(".js-gift-card-previous");
    this.buttonNext = this.querySelector(".js-gift-card-next");
    if (!this.slider || !this.list || this.slides.length === 0) {
      return;
    }
    loadSwiper().then(() => {
      if (!this.isConnected || this.swiper) {
        return;
      }
      this.initSwiper();
    });
  }
  disconnectedCallback() {
    this.destroySwiper();
  }
  initSwiper() {
    this.slider.classList.add("swiper");
    this.list.classList.add("swiper-wrapper");
    this.slides.forEach((slide) => slide.classList.add("swiper-slide"));
    const gap = Number(this.dataset.gap) || 18;
    this.swiper = new window.Swiper(this.slider, {
      breakpoints: {
        [DESKTOP_BREAKPOINT]: {
          slidesPerView: Number(this.dataset.desktopSlides) || 3
        }
      },
      grabCursor: true,
      navigation: {
        nextEl: this.buttonNext,
        prevEl: this.buttonPrevious
      },
      pagination: {
        clickable: true,
        el: this.pagination
      },
      // SPはカード幅をCSSで固定し、はみ出した分をスクロールさせる
      slidesPerGroup: 1,
      slidesPerView: "auto",
      spaceBetween: gap,
      speed: 500,
      watchOverflow: true
    });
    this.classList.add("is-initialized");
  }
  destroySwiper() {
    var _a, _b, _c;
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    this.classList.remove("is-initialized");
    (_a = this.slider) == null ? void 0 : _a.classList.remove("swiper");
    (_b = this.list) == null ? void 0 : _b.classList.remove("swiper-wrapper");
    (_c = this.slides) == null ? void 0 : _c.forEach((slide) => slide.classList.remove("swiper-slide"));
  }
}
if (!customElements.get("original-gift-card-slider")) {
  customElements.define("original-gift-card-slider", OriginalGiftCardSlider);
}
const DESKTOP_MEDIA_QUERY = "(min-width: 750px)";
class OriginalFooterShops extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector(".js-footer-shops-slider");
    this.list = this.querySelector(".js-footer-shops-list");
    this.slides = [...this.querySelectorAll(".js-footer-shops-slide")];
    this.pagination = this.querySelector(".js-footer-shops-pagination");
    this.buttonPrevious = this.querySelector(".js-footer-shops-previous");
    this.buttonNext = this.querySelector(".js-footer-shops-next");
    this.desktopMediaQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);
    this.handleMediaChange = this.handleMediaChange.bind(this);
    if (!this.slider || !this.list || this.slides.length === 0) {
      return;
    }
    this.desktopMediaQuery.addEventListener("change", this.handleMediaChange);
    this.handleMediaChange();
  }
  disconnectedCallback() {
    var _a;
    (_a = this.desktopMediaQuery) == null ? void 0 : _a.removeEventListener("change", this.handleMediaChange);
    this.destroySwiper();
  }
  handleMediaChange() {
    if (!this.desktopMediaQuery.matches) {
      this.destroySwiper();
      return;
    }
    loadSwiper().then(() => {
      if (!this.isConnected || !this.desktopMediaQuery.matches || this.swiper) {
        return;
      }
      this.initSwiper();
    });
  }
  initSwiper() {
    this.slider.classList.add("swiper");
    this.list.classList.add("swiper-wrapper");
    this.slides.forEach((slide) => slide.classList.add("swiper-slide"));
    this.swiper = new window.Swiper(this.slider, {
      grabCursor: true,
      navigation: {
        nextEl: this.buttonNext,
        prevEl: this.buttonPrevious
      },
      pagination: {
        clickable: true,
        el: this.pagination
      },
      slidesPerGroup: 1,
      slidesPerView: 5,
      spaceBetween: 20,
      speed: 500,
      watchOverflow: true
    });
    this.classList.add("is-initialized");
  }
  destroySwiper() {
    var _a, _b, _c;
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    this.classList.remove("is-initialized");
    (_a = this.slider) == null ? void 0 : _a.classList.remove("swiper");
    (_b = this.list) == null ? void 0 : _b.classList.remove("swiper-wrapper");
    (_c = this.slides) == null ? void 0 : _c.forEach((slide) => slide.classList.remove("swiper-slide"));
  }
}
if (!customElements.get("original-footer-shops")) {
  customElements.define("original-footer-shops", OriginalFooterShops);
}
class OriginalHorizontalScrollbar extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector(".js-horizontal-scrollbar-viewport");
    this.track = this.querySelector(".js-horizontal-scrollbar-track");
    this.thumb = this.querySelector(".js-horizontal-scrollbar-thumb");
    if (!this.viewport || !this.track || !this.thumb) {
      return;
    }
    this.handleUpdate = this.handleUpdate.bind(this);
    this.viewport.addEventListener("scroll", this.handleUpdate, { passive: true });
    this.resizeObserver = new ResizeObserver(this.handleUpdate);
    this.resizeObserver.observe(this.viewport);
    this.resizeObserver.observe(this.track);
    this.handleUpdate();
  }
  disconnectedCallback() {
    var _a, _b;
    (_a = this.viewport) == null ? void 0 : _a.removeEventListener("scroll", this.handleUpdate);
    (_b = this.resizeObserver) == null ? void 0 : _b.disconnect();
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
  }
  handleUpdate() {
    if (this.animationFrame) {
      return;
    }
    this.animationFrame = requestAnimationFrame(() => {
      this.animationFrame = null;
      this.updateScrollbar();
    });
  }
  updateScrollbar() {
    const scrollRange = this.viewport.scrollWidth - this.viewport.clientWidth;
    const isScrollable = scrollRange > 0;
    this.track.hidden = !isScrollable;
    if (!isScrollable) {
      return;
    }
    const visibleRatio = this.viewport.clientWidth / this.viewport.scrollWidth;
    const thumbWidth = this.track.clientWidth * visibleRatio;
    const scrollProgress = Math.min(Math.max(this.viewport.scrollLeft / scrollRange, 0), 1);
    const thumbPosition = (this.track.clientWidth - thumbWidth) * scrollProgress;
    this.thumb.style.width = `${visibleRatio * 100}%`;
    this.thumb.style.transform = `translate3d(${thumbPosition}px, 0, 0)`;
  }
}
if (!customElements.get("original-horizontal-scrollbar")) {
  customElements.define("original-horizontal-scrollbar", OriginalHorizontalScrollbar);
}
